export default __webpack_public_path__ + "static/media/courtesyPage.d747b332.svg";